<template>
  <div class="step-conteudo">
    <div class="step-conteudo__section">
      <div class="section-label">Tipo de conteúdo</div>
      <div class="step-conteudo__tipos-grid">
        <SelectableCard
          v-for="tipo in tiposDisponiveis"
          :key="tipo.chave"
          :value="tipo.chave"
          :label="tipo.label"
          :description="tipo.description"
          :icon="tipo.icon"
          :selected="item.conteudo_tipo === tipo.chave"
          @select="selecionarTipo"
        />
      </div>
    </div>

    <div v-if="ehHtml" class="form-group">
      <editor-conteudo :item="item"></editor-conteudo>
    </div>

    <template v-else-if="ehTexto">
      <CRow>
        <CCol md="7">
          <div class="form-group">
            <label class="field-label">Título</label>
            <input
              class="form-control form-control-sm"
              v-model="item.titulo"
              maxlength="255"
              placeholder="Ex.: Atendimento para todo o Brasil"
            />
            <div v-if="validacao.firstError('item.titulo')" class="message">
              {{ validacao.firstError("item.titulo") }}
            </div>
          </div>
          <div class="form-group">
            <label class="field-label">Subtítulo</label>
            <input
              class="form-control form-control-sm"
              v-model="item.subtitulo"
              maxlength="255"
              placeholder="Ex.: Condições especiais para empresas"
            />
          </div>
          <div class="form-group">
            <label class="field-label">Resumo</label>
            <textarea
              class="form-control form-control-sm"
              v-model="item.resumo"
              rows="4"
              maxlength="2000"
              placeholder="Texto curto de apoio exibido no bloco"
            ></textarea>
          </div>
        </CCol>
        <CCol md="5">
          <SeletorImagem
            label="Imagem do bloco (opcional)"
            v-model="item.imagem_fundo"
            dica="Fundo ou ilustração ao lado do texto"
          />
        </CCol>
      </CRow>

      <div class="step-conteudo__preview">
        <div class="section-label">Prévia</div>
        <PreviewBlocoTexto :item="item" />
      </div>
    </template>

    <template v-else>
      <CRow>
        <CCol md="6">
          <SeletorImagem :label="`Desktop · ${tamanho.desktop}`" v-model="item.imagem" />
          <div v-if="validacao.firstError('item.imagem')" class="message">
            {{ validacao.firstError("item.imagem") }}
          </div>
        </CCol>
        <CCol md="6">
          <SeletorImagem :label="`Mobile · ${tamanho.mobile}`" v-model="item.imagem_mobile" />
          <div v-if="validacao.firstError('item.imagem_mobile')" class="message">
            {{ validacao.firstError("item.imagem_mobile") }}
          </div>
        </CCol>
      </CRow>
      <p v-if="slotHome" class="step-conteudo__hint">
        <CIcon name="cil-info" size="sm" class="mr-1" />
        Medidas recomendadas para {{ tamanho.percentual }} da linha. A largura é ajustada na aba
        Aparência.
      </p>
    </template>
  </div>
</template>

<script>
import SelectableCard from "@/views/Campanhas/components/CampanhasComerciais/shared/SelectableCard.vue";
import SeletorImagem from "@/components/base/SeletorImagem.vue";
import EditorConteudo from "@/components/EditorConteudo.vue";
import PreviewBlocoTexto from "../shared/PreviewBlocoTexto.vue";
import { TIPOS_CONTEUDO, tamanhoRecomendado } from "../helpers/conteudoLabels";
import {
  ehBlocoTexto,
  ehConteudoHtml,
  ehTipoSeguranca,
  ehTipoSlotHome,
} from "../helpers/blocoConteudo";

const TIPOS_SEGURANCA = [
  { chave: "IMAGEM", label: "Imagem", description: "Selo em imagem", icon: "cil-image-plus" },
  { chave: "HTML", label: "HTML", description: "Código do selo fornecido pela certificadora", icon: "cil-code" },
];

export default {
  name: "StepConteudo",
  components: { SelectableCard, SeletorImagem, EditorConteudo, PreviewBlocoTexto },
  props: {
    item: {
      type: Object,
      required: true,
    },
    validacao: {
      type: Object,
      required: true,
    },
  },
  computed: {
    slotHome() {
      return ehTipoSlotHome(this.item);
    },
    tiposDisponiveis() {
      if (ehTipoSeguranca(this.item)) {
        return TIPOS_SEGURANCA;
      }

      if (this.slotHome) {
        return Object.keys(TIPOS_CONTEUDO).map((chave) => ({ chave, ...TIPOS_CONTEUDO[chave] }));
      }

      return [{ chave: this.item.conteudo_tipo, ...TIPOS_CONTEUDO.imagem }];
    },
    ehTexto() {
      return ehBlocoTexto(this.item);
    },
    ehHtml() {
      return ehTipoSeguranca(this.item) && ehConteudoHtml(this.item);
    },
    tamanho() {
      return tamanhoRecomendado(this.item);
    },
  },
  methods: {
    selecionarTipo(tipo) {
      if (this.item.conteudo_tipo === tipo) {
        return;
      }

      this.$set(this.item, "conteudo_tipo", tipo);

      if (ehTipoSeguranca(this.item)) {
        this.$set(this.item, "imagem", null);
        this.$set(this.item, "imagem_mobile", null);
        this.$set(this.item, "conteudo", "");
      }
    },
  },
};
</script>

<style scoped>
.field-label {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
  display: block;
}

.message {
  font-size: 11px;
  color: #d92d20;
  margin-top: 2px;
}

.step-conteudo__section {
  margin-bottom: 14px;
}

.section-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #888;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}

.step-conteudo__tipos-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.step-conteudo__preview {
  margin-top: 6px;
  padding: 14px;
  border: 1px dashed #d0d5dd;
  border-radius: 10px;
  background: #f9fafb;
}

.step-conteudo__hint {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #667085;
  margin: 10px 0 0;
}

@media (max-width: 768px) {
  .step-conteudo__tipos-grid {
    grid-template-columns: 1fr;
  }
}
</style>
